<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-11-01 11:44:49
-->
<template>
  <div
    class="component--text-editor inputable"
    draggable="false"
    @click="$refs.content && $refs.content.focus()"
  >
    <div
      @click="$refs.content && $refs.content.focus()"
      v-if="!isEditing && isBlank(displayValue)"
      class="answer-input__tooltip"
    >
      {{ placeholder }}
    </div>
    <div
      ref="content"
      :contenteditable="!readonly"
      draggable="false"
      :class="[
        'answer-input__content',
        'original-text',
        textDirection === 'rtl' ? 'rtl-important' : null,
      ]"
      @keydown="handleKeyDown"
      @keyup="handleKeyUp"
      @paste="handlePaste"
      @dragover="preventDefault"
      @drop="preventDefault"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
    ></div>
  </div>
</template>

<script>
import { isBlank } from "../utils/String";
export default {
  props: {
    value: String,
    postilManager: {
      type: Object,
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    textDirection: String,
    allowEnter: {
      type: Boolean,
      default: false,
    },
    allowEmptyInput: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isEditing: false,
      previewText: null,
      displayValue: null,
    };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          if (!this.$refs.content) return;

          const editingText = this.$refs.content.textContent;
          if (newValue != editingText) {
            this.$refs.content.textContent = newValue;
          }
          this.displayValue = newValue;
        });
      },
    },
  },
  methods: {
    isBlank,
    handleKeyDown(event) {
      if (event.key && ["Delete", "Insert"].indexOf(event.key) >= 0) {
        event.preventDefault();
      }

      //prevent ctrl+x, ctrl+b and ctrl+i
      if (event.ctrlKey && event.key && ["b", "i"].indexOf(event.key) >= 0) {
        event.preventDefault();
      }

      //13:enter-code => nowrap
      if (event.charCode == 13 || event.key == "Enter") {
        if (this.allowEnter) {
        } else {
          event.preventDefault();
        }
      }
    },
    handleKeyUp(event) {
      //13:enter-code => nowrap
      if (event.charCode == 13 || event.key == "Enter") {
        if (this.allowEnter) {
        } else {
          event.preventDefault();
          return;
        }
      }
    },
    handlePaste(ev) {
      if (ev.clipboardData) {
        ev.preventDefault();
        const clipboardData = ev.clipboardData;
        const text = clipboardData.getData("text");
        if (text && text.length > 0 && window.getSelection) {
          const textNode = document.createTextNode(text);
          let range = window.getSelection().getRangeAt(0);
          range.deleteContents();
          range.insertNode(textNode);
          range.setStartAfter(textNode);
          range.detach();
        }
      }
    },
    preventDefault(ev) {
      ev.preventDefault();
      return false;
    },
    handleFocus() {
      this.isEditing = true;
      this.$emit("editstart");
      this.previewText = this.$refs.content.textContent;
    },
    _updateDisplayValue() {
      this.displayValue = this.$refs.content.textContent;
    },
    handleBlur() {
      this.isEditing = false;
      this.$emit("startEnd");
      const newText = this.$refs.content.textContent;
      if (newText != this.previewText) {
        if (!this.allowEmptyInput && isBlank(newText)) {
          this.$refs.content.textContent = this.previewText;
        } else {
          this.$emit("input", newText);
          this.$emit("change", {
            newValue: newText,
            oldValue: this.previewText,
          });
        }
      }
    },
    handleInput(ev) {
      this._updateDisplayValue();
    },
  },
  mounted() {
    this.$refs.content.textContent = this.displayValue = this.value || "";
  },
};
</script>

<style lang="scss">
.component--text-editor {
  position: relative;
  background: transparent;
  overflow: auto;

  > .answer-input__tooltip {
    position: absolute;
    left: 15px;
    top: 5px;

    font-size: 14px;
    cursor: text;
    color: #c0c4cc;
  }

  > .answer-input__content {
    min-height: 24px;
    line-height: 1.5;
    outline-width: 0;
    white-space: normal;
    font-size: 14px;
    cursor: text;
    outline-style: none;
  }

  .popover-content {
    padding: 0px;
    border-radius: 4px;
  }
}
</style>